module.exports = __webpack_public_path__ + "bg_menu.png?7174dd4b5036b0d2451eef198039a986";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_menu.png
// module id = 8
// module chunks = 0